<template>
	<div :class="classes">
		<div :class="leftSegmentClasses"
			@click="$emit( `change`, leftSegmentName )"
		>
			<slot name="left-segment"></slot>
		</div>
		<div :class="rightSegmentClasses"
			@click="$emit( `change`, rightSegmentName )"
		>
			<slot name="right-segment"></slot>
		</div>
	</div>
</template>

<script>
import {
	DirectionOrientation
} from "@teaming/common-enums";

export default {
	name: "TeamingSegmentedButton",
	emits: [ "change", ],
	props: {
		/* @deprecated: prefer class attribute */
		className: {
			type: String,
			default: "",
		},
		activeSegmentName: {
			type: String,
			default: "left",
		},
		leftSegmentName: {
			type: String,
			default: "left",
		},
		rightSegmentName: {
			type: String,
			default: "right",
		},
		orientation: {
			type: String,
			default: DirectionOrientation.HORIZONTAL,
			validator: value => DirectionOrientation.includes( value ),
		},
	},
	computed: {
		classes() {
			const { orientation, className, } = this;
			return {
				"teaming-segmented-button": true,
				"teaming-segmented-button--horizontal": orientation === DirectionOrientation.HORIZONTAL,
				"teaming-segmented-button--vertical": orientation === DirectionOrientation.VERTICAL,
				[ className ]: !!className,
			};
		},
		leftSegmentClasses() {
			return {
				segment: true,
				"segment--left": true,
				"segment--active": this.activeSegmentName === this.leftSegmentName ||
					this.activeSegmentName !== this.rightSegmentName,
			};
		},
		rightSegmentClasses() {
			return {
				segment: true,
				"segment--right": true,
				"segment--active": this.activeSegmentName === this.rightSegmentName,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.teaming-segmented-button {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	background-color: $teaming-segmented-button-background;
	border: 0.0625rem solid $teaming-segmented-button-border;
	border-radius: 0.5rem;
}

.teaming-segmented-button--horizontal {
	flex-direction: row;
}

.teaming-segmented-button--vertical {
	flex-direction: column;
}

.segment {
	@include font-and-line-for(1);
	font-weight: 600;
	flex: 0 0 50%;
	padding: 0.625rem 0.375rem;
	color: $teaming-segmented-button-segment-font-color;
	text-align: center;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	cursor: pointer;

	// text is not selectable
	-webkit-user-select: none; /* Safari */
	-moz-user-select: none; /* Firefox */
	-ms-user-select: none; /* IE10+/Edge */
	user-select: none; /* Standard */
}

.segment--active {
	color: $teaming-segmented-button-active-font-color;
	background-color: $teaming-segmented-button-active-background;
	border: 0.0625rem solid $teaming-segmented-button-border--active;
	box-shadow: 0 0.1875rem 0.375 0.0625rem rgba(33, 45, 99, 0.1), 0 1.3125rem 1.875rem -1.25rem rgba(33, 45, 99, 0.2);
	border-radius: 0.5rem;
	cursor: default;
}
</style>
